import type { FormComponent, FormState, WorkflowDetail } from '@/types/workflow'

export const NATIVE_MULTI_OUTPUT_WORKFLOW_ID = '9e4f1022-68ea-44bb-a14c-40f880652e62'

const DIRECTION_COUNT_TITLE = '创作方向数量'
const BRANCH_COUNT_TITLE = '每种创作方向裂变提示词数量'
const DIRECTION_COUNT_PARAM = 'param_1774941633009'
const BRANCH_COUNT_PARAM = 'param_1772315527065'

export function isNativeMultiOutputWorkflow(workflowId: string | undefined): boolean {
  return workflowId === NATIVE_MULTI_OUTPUT_WORKFLOW_ID
}

export function resolveNativeOutputMultiplier(
  workflow: WorkflowDetail | undefined,
  formState: FormState
): number {
  if (workflow === undefined || !isNativeMultiOutputWorkflow(workflow.id)) {
    return 1
  }

  const directionCount = resolveComponentValue(
    workflow.form_components,
    formState,
    DIRECTION_COUNT_TITLE,
    DIRECTION_COUNT_PARAM
  )
  const branchCount = resolveComponentValue(
    workflow.form_components,
    formState,
    BRANCH_COUNT_TITLE,
    BRANCH_COUNT_PARAM
  )

  return Math.max(1, directionCount) * Math.max(1, branchCount)
}

function resolveComponentValue(
  components: FormComponent[],
  formState: FormState,
  title: string,
  fallbackParam: string
): number {
  const component = components.find((item) => item.title === title) ??
    components.find((item) => item.param_name === fallbackParam)

  const paramName = component?.param_name ?? fallbackParam
  const rawValue = formState[paramName] ?? formState[fallbackParam] ?? component?.default_value
  let value = parseInteger(rawValue, 1)

  const config = component?.config
  const min = parseInteger(getConfigNumber(config, 'min'), Number.NaN)
  const max = parseInteger(getConfigNumber(config, 'max'), Number.NaN)
  if (Number.isFinite(min)) {
    value = Math.max(value, min)
  }
  if (Number.isFinite(max)) {
    value = Math.min(value, max)
  }

  return value > 0 ? value : 1
}

function getConfigNumber(config: FormComponent['config'] | undefined, key: 'min' | 'max'): unknown {
  if (config === null || typeof config !== 'object') {
    return undefined
  }
  return (config as Record<string, unknown>)[key]
}

function parseInteger(value: unknown, fallback: number): number {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.trunc(value)
  }
  if (typeof value === 'string') {
    const parsed = Number(value.trim())
    if (Number.isFinite(parsed)) {
      return Math.trunc(parsed)
    }
  }
  return fallback
}
